import { memoize } from 'lodash';
import { createSelector } from 'reselect';
import { State } from '.';
import { Snomed } from '../../models/snomed';

const getOtherSnomedIdsSelector = createSelector(
    (state: State) => state.byId,
    (byId: Dictionary<Snomed>) => memoize((
        conceptIds: Undefinable<number>[]
    ) => conceptIds.filter(x => x && !byId[x]) as number[])
);

const getSnomedIdsByTextSelector = createSelector(
    (state: State) => state.byId,
    (byId: Dictionary<Snomed>) => memoize((
        text: Undefinable<string>
    ) => {
        const textLower = (text || '').toLowerCase();
        return Object
            .keys(byId)
            .filter(x => byId[x] && (byId[x]!.term || '').toLowerCase().startsWith(textLower))
            .map(x => +x);
    })
);

export const selectors = {
    checkSearched: (
        state: State,
        text: string
    ): boolean => state.searchedTextHash[text] || false,
    getLoading: (
        state: State,
        loadingKey: string
    ): boolean => state.loading[loadingKey] || false,
    getOtherSnomedIds: (
        state: State,
        conceptIds: Undefinable<number>[]
    ): number[] => getOtherSnomedIdsSelector(state)(conceptIds),
    getSnomed: (
        state: State,
        code: Undefinable<DictionaryKey>
    ): Undefinable<Snomed> => state.byId[code || ''],
    getSnomedIds: (
        state: State
    ): string[] => state.allIds,
    getSnomedIdsByText: (
        state: State,
        text: string
    ): number[] => getSnomedIdsByTextSelector(state)(text)
};
